import './Mayoreo.css'

const CHUPON = [
  {
    id: 1,
    cantidad: '1 vaso',
    precio: '$24.99',
    precioUnit: 'precio único',
    mejor: false,
  },
  {
    id: 2,
    cantidad: '50 vasos o más',
    precio: '$21.99',
    precioUnit: '$140 c/u',
    mejor: false,
  },
  {
    id: 3,
    cantidad: '100 vasos o más',
    precio: '$19.99',
    precioUnit: '$125 c/u',
    mejor: true,
  },
]

const LIBERTY_MINI = [
  {
    id: 1,
    cantidad: '1 vaso',
    precio: '$150',
    precioUnit: 'precio único',
    mejor: false,
  },
  {
    id: 2,
    cantidad: '3 vasos',
    precio: '$420',
    precioUnit: '$140 c/u',
    mejor: false,
  },
  {
    id: 3,
    cantidad: '6 vasos',
    precio: '$750',
    precioUnit: '$125 c/u',
    mejor: true,
  },
]

const LIBERTY_GRANDE = [
  {
    id: 1,
    cantidad: '1 vaso',
    precio: '$65.99',
    precioUnit: 'precio único',
    mejor: false,
  },
  {
    id: 2,
    cantidad: '10 vasos',
    precio: '$559.90',
    precioUnit: '$55.99 c/u',
    mejor: false,
  },
  {
    id: 3,
    cantidad: '50 vasos',
    precio: '$2,499.50',
    precioUnit: '$49.99 c/u',
    mejor: true,
  },
]

export default function Mayoreo({ waNumber }) {
  const buildWaUrl = (plan) => {
    const msg = encodeURIComponent(
      `Hola! Me interesa el paquete de *${plan.cantidad}* LIBERTY a ${plan.precio}`
    )
    return `https://wa.me/${waNumber}?text=${msg}`
  }

  const renderFila = (planes) =>
    planes.map((plan) => (
      <div key={plan.id} className={`mayoreo-card ${plan.mejor ? 'mejor' : ''}`}>
        {plan.mejor && <span className="mejor-badge">Mejor precio</span>}
        <p className="plan-cantidad">{plan.cantidad}</p>
        <p className="plan-precio">{plan.precio}</p>
        <p className="plan-unit">{plan.precioUnit}</p>
        <a className="plan-cta" href={buildWaUrl(plan)} target="_blank" rel="noreferrer">
          Pedir →
        </a>
      </div>
    ))

  return (
    <div id="precios" className="mayoreo-div">

      <p className="producto-label">Liberty (24 oz)</p>
      <div className="mayoreo-grid">{renderFila(LIBERTY_GRANDE)}</div>

      <p className="mayoreo-nota">
        Precios ya incluyen el personalizado. No hay costos extra.
      </p>

    </div>
  )
}